<script>
  import makeChart from '../baseChartWidget'
  import chart from './chart'

  export default makeChart('categorySpend-wdg-cmp', chart)
</script>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/CategorySpend/index.vue